import { Calendar, MapPin, User } from 'lucide-react';
import BookingResultView, { type BookingResultResponse } from '../components/BookingResultView';

function formatCourt(court: string): string {
  if (!court) return '';
  const parts = court.split('-');
  const first = parts[0].charAt(0).toUpperCase() + parts[0].slice(1);
  return parts.length === 1 ? first : `${first} ${parts.slice(1).join(' ')}`;
}

function formatStart(iso: string): string {
  if (!iso) return '';
  try {
    const d = new Date(iso);
    const fmt = new Intl.DateTimeFormat('de-DE', {
      weekday: 'long', day: '2-digit', month: '2-digit',
      year: 'numeric', hour: '2-digit', minute: '2-digit',
      timeZone: 'Europe/Berlin',
    });
    const s = fmt.format(d).replace(',', '') + ' Uhr';
    const parts = s.split(' ');
    if (parts.length > 0) parts[0] = parts[0].charAt(0).toUpperCase() + parts[0].slice(1);
    return parts.join(' ');
  } catch {
    return iso;
  }
}

export default function BookingSuccessPage() {
  const p = new URLSearchParams(window.location.search);
  const court = p.get('court') || '';
  const start = p.get('start') || '';
  const name = p.get('name') || '';
  const resultParam = p.get('result');

  let result: BookingResultResponse | null = null;
  if (resultParam) {
    try {
      result = JSON.parse(resultParam);
    } catch {
      result = null;
    }
  }

  // If no result param at all, treat as success (legacy redirect without result data)
  if (!resultParam) {
    result = { success: true, bookingConfirmed: true };
  }

  const formattedCourt = formatCourt(court);
  const formattedStart = formatStart(start);

  const detailRows = [
    name && { icon: User, label: 'Name', value: name },
    formattedCourt && { icon: MapPin, label: 'Platz', value: formattedCourt },
    formattedStart && { icon: Calendar, label: 'Datum & Uhrzeit', value: formattedStart },
  ].filter(Boolean) as { icon: React.ElementType; label: string; value: string }[];

  return (
    <BookingResultView
      result={result}
      autoRedirect={result?.success === true && result?.bookingConfirmed === true}
      redirectUrl="https://svheinersreuth-padel.de/"
      detailRows={detailRows.length > 0 ? detailRows : undefined}
      onNavigateBooking={() => { window.location.href = '/?page=booking'; }}
    />
  );
}
